module.exports = __webpack_public_path__ + "img/arrow.f3ae7c2991ecdff124fc61b3cec1b631.svg";